import React, { useId } from 'react'
import PropTypes from 'prop-types'

const BoltIcon = React.forwardRef(function BoltIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M21.92 10.62C21.77 10.25 21.4 10 21 10H15L15.97 1.24C16.08 0.8 15.88 0.35 15.49 0.13C15.34 0.04 15.17 0 15 0C14.74 0 14.48 0.1 14.29 0.29L2.28999 12.29C1.99999 12.58 1.91999 13.01 2.06999 13.38C2.21999 13.75 2.58999 14 2.98999 14H8.98999L8.01999 22.76C7.90999 23.2 8.10999 23.65 8.49999 23.87C8.64999 23.96 8.81999 24 8.98999 24C9.24999 24 9.50999 23.9 9.69999 23.71L21.7 11.71C21.99 11.42 22.07 10.99 21.92 10.62ZM10.32 20.27L10.99 14.22C11.05 13.65 10.87 13.09 10.49 12.67C10.11 12.25 9.56999 12 8.99999 12H5.40999L13.68 3.73L13.01 9.78C12.95 10.35 13.13 10.91 13.51 11.33C13.89 11.75 14.43 12 15 12H18.59L10.32 20.27Z"></path>
    </svg>
  )
})

BoltIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

BoltIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default BoltIcon
